export default __webpack_public_path__ + "img/553cc0b9d9f65c8888215edd2a4d5686.svg";